<template>
    <div class="w-1/2 text-xs mx-2 passwordRulesList">
        <p class="font-semibold">{{ $t("Forms.your_password_must_have") }}:</p>
        <ul class="list-disc ml-4">
            <li v-for="(item, index) in passwordRules" :key="index">
                {{ item }}
            </li>
        </ul>
    </div>
</template>

<script>

export default {
    props: [],
    mixins: [],
    components: {},
    data: () => ({
        passwordRules: []
    }),
    watch: {},
    computed: {},
    methods: {
        /**
         * Set the password rules translations
         */
        setPasswordRules() {
            this.passwordRules = [
                `${ this.$t("vee_validate.required") }`,
                `${ this.$t("Validations.password_uppercase_letters") }`,
                `${ this.$t("Validations.password_lowercase_letters") }`,
                `${this.$t("Validations.password_special_characters")}`,
                `${ this.$t("Validations.password_numeric_characters") }`,
                `${this.$t("Validations.password_less_eight_characters")}`
                
            ];
        },
    },
    mounted() { this.setPasswordRules(); }
};
</script>
